import React from 'react';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-plum" data-id="element-100" data-mp="1o5q1qgnuw7zz">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-101" data-mp="222whe2da9qkz">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-gold text-gold" data-id="element-102" data-mp="1x421p9am4i53">
          <span className="font-display text-4xl font-semibold leading-none" data-id="element-103" data-mp="19f0o77mxagsy">7</span>
          <span className="text-[10px] font-semibold uppercase tracking-widest" data-id="element-104" data-mp="14gz88vksmxlp">
            Days
          </span>
        </div>
        <p className="mt-6 text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-105" data-mp="1j6n7lr9ezm6s">
          Zero risk
        </p>
        <h2 id="guarantee-heading" className="mt-3 font-display font-semibold text-white text-3xl sm:text-5xl" data-id="element-106" data-mp="qnzq0ltmmpag">
          Open everything. <span className="italic text-gold" data-id="element-107" data-mp="lowkz1dncj2h">Teach a week from it.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/75" data-id="element-108" data-mp="oyqalznmtfex">
          Read the volumes, print the Week Cards, teach a class straight from
          the page. If 52 Weeks of Barre doesn&apos;t change how you plan your
          classes, email us within 7 days and you get every cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-109" data-mp="12q4x4ggqzyqq">
          {chips.map(chip => <li key={chip} className="rounded-full border border-plum-line px-4 py-2 text-[13px] text-white/75" data-id="element-110" data-mp="62i30p75csgg">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}